export default {
  getActiveCoupons: state => {
    return state.allCoupons.items.filter(
      coupon =>
        !coupon.endsAt ||
        new Date(coupon.endsAt) > new Date() ||
        coupon.numberSent >= coupon.numberCreated
    );
  },
  getInactiveCoupons: state => {
    return state.allCoupons.items.filter(
      coupon =>
        !(
          !coupon.endsAt ||
          new Date(coupon.endsAt) > new Date() ||
          coupon.numberSent >= coupon.numberCreated
        )
    );
  },
};
